import z from 'zod';
import {firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {repeatSchema} from './repeatSchema';
import {todoStatusSchema} from './TodoStatus';

export const todoWriteSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  note: z.string().optional(),
  done: z.union([firestoreTimestampSchema, z.null()]),
  repeat: repeatSchema.nullable().optional(),
  status: todoStatusSchema,
  tags: z.array(z.string()).default([]),
});

export interface TodoWrite extends z.infer<typeof todoWriteSchema> {}
